/*=========================================================================================
  File Name: state.js
  Namespace: lpaths
  Description: Vuex Store - Learning Path state
==========================================================================================*/

const LPATH_POSSIBLE_STATUS = {
  DRAFT: "draft",
  COMMING_SOON: "coming soon",
  PUBLISHED: "published",
  ARCHIVED: "archived",
  UNPUBLISHED: "unpublished"
}

const LPATH_POSSIBLE_DIFFICULTY = {
  INFORMATIVE: "informative",
  NOVICE: "novice",
  PROFESSIONAL: "professional",
  ADVANCED: "advanced",
  EXPERT: "expert"
}

export const buildLPathState = () => {
  return {
    id: null,
    name: '',
    slug: '',
    url: '',
    description: '',
    content: [],
    instructors: [],
    difficulty: null,
    learning_areas: [],
    categories: [],
    vendors: [],
    tags: [],
    status: LPATH_POSSIBLE_STATUS.DRAFT,
    trailer_jwplayer_id: '',
    auto_publish_at: null,
    published_date: null,
    created: null,
    modified: null,
    bg_image_url: '',
    duration_in_seconds: 0,
    images: {
      main_image_url: ''
    },
    is_featured: false,
    access: {
      related_passes: [],
      user_passes: [],
      has_access: null
    },
    direct_passes: [],
    next_learning_path: null,
    next_learning_path_item: null,
    closing_video_jwplayer_id: '',
    closing_video_remarks: ''
  }
}

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  currentLPath: buildLPathState(),
  lpathList: null,
  count: 0,
  next: null,
  previous: null,
  results: [],
  LPATH_POSSIBLE_STATUS: LPATH_POSSIBLE_STATUS,
  LPATH_POSSIBLE_DIFFICULTY: LPATH_POSSIBLE_DIFFICULTY,
  lpathStatusTransitions: {
    [LPATH_POSSIBLE_STATUS.DRAFT]: [LPATH_POSSIBLE_STATUS.DRAFT, LPATH_POSSIBLE_STATUS.COMMING_SOON, LPATH_POSSIBLE_STATUS.PUBLISHED],
    [LPATH_POSSIBLE_STATUS.COMMING_SOON]: [LPATH_POSSIBLE_STATUS.COMMING_SOON, LPATH_POSSIBLE_STATUS.DRAFT, LPATH_POSSIBLE_STATUS.PUBLISHED],
    [LPATH_POSSIBLE_STATUS.PUBLISHED]: [LPATH_POSSIBLE_STATUS.PUBLISHED, LPATH_POSSIBLE_STATUS.ARCHIVED, LPATH_POSSIBLE_STATUS.UNPUBLISHED],
    [LPATH_POSSIBLE_STATUS.ARCHIVED]: [LPATH_POSSIBLE_STATUS.ARCHIVED, LPATH_POSSIBLE_STATUS.PUBLISHED, LPATH_POSSIBLE_STATUS.UNPUBLISHED],
    [LPATH_POSSIBLE_STATUS.UNPUBLISHED]: [LPATH_POSSIBLE_STATUS.UNPUBLISHED, LPATH_POSSIBLE_STATUS.PUBLISHED]
  }
}

export default state